export interface ParcelStatusEnum {
  value: number
  name: string
  i18nKey: string
}

export const parcelStatusEnumList: ParcelStatusEnum[] = [
  {
    value: 0,
    name: "UNKNOWN",
    i18nKey: "entity.parcel.upload.status.unknown"
  },
  {
    value: 1,
    name: "CANCELLED",
    i18nKey: "entity.parcel.upload.status.cancelled"
  },
  {
    value: 2,
    name: "CANCELLED_SENT",
    i18nKey: "entity.parcel.upload.status.cancelled_sent"
  },
  {
    value: 3,
    name: "PREPARED_TO_CANCEL",
    i18nKey: "entity.parcel.upload.status.prepared_to_cancel"
  },
  {
    value: 100,
    name: "CREATED",
    i18nKey: "entity.parcel.upload.status.created"
  },
  {
    value: 101,
    name: "NOT_YET_PRINTED",
    i18nKey: "entity.parcel.upload.status.not_yet_printed"
  },
  {
    value: 102,
    name: "DELETED",
    i18nKey: "entity.parcel.upload.status.deleted"
  },
  {
    value: 103,
    name: "PRINTED",
    i18nKey: "entity.parcel.upload.status.printed"
  },
  {
    value: 104,
    name: "SENT",
    i18nKey: "entity.parcel.upload.status.sent"
  },
  {
    value: 105,
    name: "PREPARED_TO_SEND",
    i18nKey: "entity.parcel.upload.status.prepared_to_send"
  },
  {
    value: 1001,
    name: "CONSOLIDATION",
    i18nKey: "entity.parcel.upload.status.consolidation"
  },
  {
    value: 1002,
    name: "INBOUND_",
    i18nKey: "entity.parcel.upload.status.inbound"
  },
  {
    value: 1003,
    name: "OUT_FOR_DELIVERY",
    i18nKey: "entity.parcel.upload.status.out_for_delivery"
  },
  {
    value: 1004,
    name: "DRIVERS_RETURN",
    i18nKey: "entity.parcel.upload.status.drivers_return"
  },
  {
    value: 1005,
    name: "PICK_UP",
    i18nKey: "entity.parcel.upload.status.picked_up"
  },
  {
    value: 1006,
    name: "SYSTEM_RETURN",
    i18nKey: "entity.parcel.upload.status.system_return"
  },
  {
    value: 1008,
    name: "WAREHOUSE",
    i18nKey: "entity.parcel.upload.status.warehouse"
  },
  {
    value: 1009,
    name: "INBOUND_EXCEPTION",
    i18nKey: "entity.parcel.upload.status.inbound_exception"
  },
  {
    value: 1010,
    name: "HUB_SCAN",
    i18nKey: "entity.parcel.upload.status.hub_scan"
  },
  {
    value: 1012,
    name: "CUSTOMS_CLEARANCE_PROCESS",
    i18nKey: "entity.parcel.upload.status.customs_clearance_process"
  },
  {
    value: 1013,
    name: "DELIVERED",
    i18nKey: "entity.parcel.upload.status.delivered"
  },
  {
    value: 1014,
    name: "DELIVERY_ATTEMPT_NOT_SUCCESSFUL",
    i18nKey: "entity.parcel.upload.status.delivery_attempt_not_successful"
  },
  {
    value: 1015,
    name: "DRIVERS_PICK_UP",
    i18nKey: "entity.parcel.upload.status.drivers_pick_up"
  },
  {
    value: 1017,
    name: "EXPORT_IMPORT_CLEARED",
    i18nKey: "entity.parcel.upload.status.export_import_cleared"
  },
  {
    value: 1018,
    name: "ADDITIONAL_INFORMATION",
    i18nKey: "entity.parcel.upload.status.additional_information"
  },
  {
    value: 1020,
    name: "LOADING",
    i18nKey: "entity.parcel.upload.status.loading"
  },
  {
    value: 1023,
    name: "DELIVERED_BY_DRIVER_TO_DPD_PARCELSHOP",
    i18nKey: "entity.parcel.upload.status.delivered_by_driver"
  },
  {
    value: 1099,
    name: "RETURN_TO_SENDER",
    i18nKey: "entity.parcel.upload.status.return_to_sender"
  }
]
